import { render, staticRenderFns } from "./smWorks.vue?vue&type=template&id=1a8d8099&"
import script from "./smWorks.vue?vue&type=script&lang=js&"
export * from "./smWorks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports